import { apiSlice } from "./apiSlice";

export const smsProviderApi = apiSlice
    .enhanceEndpoints({ addTagTypes: ['SMS-PROVIDER'] })
    .injectEndpoints({
        keepUnusedDataFor: 1,
        endpoints: builder => ({
            getMerchantSmsProvider: builder.query({
                query: (merchantId) => ({
                    url: `/sms-provider/${merchantId}`,
                    method: 'GET',
                }),
                providesTags: [{ type: 'SMS-PROVIDER', id: 'SMS-PROVIDER-PARTIAL-LIST' }],
                transformResponse: (response, meta, arg) => response?.body,
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            updateMerchantSmsProvider: builder.mutation({
                query: ({ merchantId, payload }) => ({
                    url: `/sms-provider/${merchantId}`,
                    method: 'PUT',
                    body: { ...payload }
                }),
                invalidatesTags: () => [
                    // { type: "SMS-PROVIDER", id },
                    { type: "SMS-PROVIDER", id: "SMS-PROVIDER-PARTIAL-LIST" },
                ],
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
        })
    })

export const {
    useGetMerchantSmsProviderQuery,
    useUpdateMerchantSmsProviderMutation
} = smsProviderApi